import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";
import { REACT_APP_MULTI_LANG } from "../config";

const HeaderTools = props => {
  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };
  if (!REACT_APP_MULTI_LANG) {
    return null;
  }

  return (
    <Translation>
      {t => (
        <div id="language">
          <em>Language:</em>
          <a onClick={() => changeLanguage("en")}>EN</a>
          <a onClick={() => changeLanguage("fr")}>FR</a>
        </div>
      )}
    </Translation>
  );
};

export default HeaderTools;
